import type React from "react";

import {faExpand} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const FullscreenButton: React.FC = () => {
  const handleFullscreenToggle = () => {
    if (!document.fullscreenElement) {
      document.documentElement
        .requestFullscreen()

        .catch((err) => {
          console.error(`Failed to enter fullscreen mode: ${err.message}`);
        });
    }
  };

  return (
    <button
      onClick={handleFullscreenToggle}
      className="bg-yellow-500  text-white py-2 px-4 rounded mt-10"
      aria-label="Enter fullscreen mode"
    >
      <FontAwesomeIcon icon={faExpand} />
    </button>
  );
};

export default FullscreenButton;
